import { render, staticRenderFns } from "./ProductRelationshipEditor.vue?vue&type=template&id=23b8190c&scoped=true&"
import script from "./ProductRelationshipEditor.vue?vue&type=script&lang=js&"
export * from "./ProductRelationshipEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b8190c",
  null
  
)

export default component.exports